// src/components/home/ContactSection.jsx
import React from 'react';
import contactBg from '../../assets/A-Contact-bg.png';

const ContactSection = () => {
  return (
    <section id="contact" className="bg-[#F3ECE2] py-16 sm:py-20 md:py-24 px-4 sm:px-6 lg:px-8 font-poppins">
      <div className="max-w-7xl mx-auto">
        <div
          className="relative bg-cover bg-center bg-no-repeat rounded-3xl overflow-hidden shadow-xl"
          style={{ backgroundImage: `url(${contactBg})`, backgroundBlendMode: 'lighten' }}
        >
          {/* Optional dark overlay for better text readability */}
          <div className="absolute inset-0 bg-black/10"></div>

          <div className="relative flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12 p-6 sm:p-10 md:p-12 lg:p-16 xl:p-20">
            {/* Left: Heading */}
            <div className="w-full lg:w-1/2 text-center lg:text-left order-2 lg:order-1">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-green-900 leading-tight font-playfair">
                Signup And Elevate Your <br className="hidden sm:block" />
                Insights, Tips & Community.
              </h2>
            </div>

            {/* Right: Form */}
            <div className="w-full lg:w-1/2 order-1 lg:order-2">
  <form className="w-full max-w-md mx-auto lg:mx-0">
    {/* Container */}
    <div className="flex flex-col lg:flex-row gap-3 lg:gap-0 items-stretch">
      {/* Input */}
      <input
        type="email"
        placeholder="Enter Email Id"
        required
        className="w-full lg:flex-1 px-6 py-4 text-gray-700 bg-amber-200 outline-none placeholder-gray-500 font-poppins text-sm sm:text-base rounded-full lg:rounded-l-full lg:rounded-r-none"
      />
      {/* Button */}
      <button
        type="submit"
        className="w-full lg:w-auto bg-[#0B2A2C] text-white font-medium px-8 py-4 transition hover:bg-green-800 rounded-full lg:rounded-r-full lg:rounded-l-none mt-2 lg:mt-0"
      >
        Submit
      </button>
    </div>

    {/* Checkbox */}
    <label className="flex items-start gap-3 mt-6 text-xs sm:text-sm text-gray-600 cursor-pointer">
      <input type="checkbox" className="mt-1 flex-shrink-0" />
      <span>Yes, I would like to receive emails with exclusive specials and offers.</span>
    </label>
  </form>
</div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;